function getFileName(path) {
    return path.split('\\').pop().split('/').pop();
}

function capture(func, logInfo, logError) {

    logError = logError || logInfo;

    // Override console log
    var oldLog = console.log;
    console.log = function () {
        logInfo([].slice.apply(arguments).join(", "));
    };

    // Attempt call to function
    let ret;
    try { ret = func(); }
    // Exception thrown
    catch (e) { logError(e); }
    finally {
        // Set back to default log
        console.log = oldLog;
        return ret;
    }
}

export default class LuaEnvironment {

    constructor(config) {

        const p = window.starlight.runtime._G.get('package');

        let logInfo, logError;

        // 
        if (config.console) {
            logInfo = config.console.info;
            logError = config.console.error;
        }

        // 
        logInfo = logInfo || ((message) => console.debug(message));
        logError = logError || ((message) => console.error(message));

        // 
        this.lua = {
            // 
            modules: {},
            // 
            starlight: window.starlight,
            runtime: window.starlight.runtime,
            // Transpiles Lua -> JS Function
            parse: function (code) {
                // Captures console output, and appends lists
                return capture(() => {
                    return window.starlight.parser.parse(code);
                }, logInfo, logError);
            },
            // Transpiles Lua -> JS Function and immediate executes
            execute: function (code) {
                let jsFunction = this.parse(code);
                return capture(jsFunction, logInfo, logError);
            },
            // Lua module tables
            preload: p.get('preload'),
            loaded: p.get('loaded')
        }
    }

    static getModuleName(path) {
        var filename = getFileName(path);
        var extPos = filename.lastIndexOf('.');
        return filename.slice(0, -(filename.length - extPos));
    }

    /**
     * Stores a module in the lua environment.
     * @param {string} modname Module name
     * @param {string} code Lua code
     */
    setModule(moduleName, code) {
        let lua = this.lua;

        // Mark the module as unloaded
        lua.loaded.set(moduleName, false);

        // Lua -> JS Function
        let jsFunction = lua.parse(code);
        if (jsFunction) {
            // Set the preload field
            lua.preload.set(moduleName, jsFunction);
            lua.modules[moduleName] = code;
        } else { 
            // Remove from modules map
            delete lua.modules[moduleName];
        }
    }

    /**
     * Execute modules in lua environment.
     */
    execute() {

        var main = "";
        Object.keys(this.lua.modules).forEach(moduleName => {
            main += `require '${moduleName}'\n`;
        });

        // 
        this.lua.execute(main);
    }
}